import React from 'react';
import Select from 'react-select';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import toast from 'react-hot-toast';
import { customDropdownStyles } from '../../data/data';
import FormCard from './FormCard';
import LiveForecastsTable from '../Common/LiveForecastsTable';
import ForecastChart from '../../charts/ForecastChart';
import AnomaliesTable from '../Common/AnomaliesTable.jsx';
import ConfirmationPopup from '../Common/ConfirmationPopup';
import TimeSeriesChart from '../../charts/timeseriesChart';
import Loading from '../Common/Loading';

const ForecastFormView = props => { // NOSONAR
  const {
    loading,
    dropdownOptions,
    selectedValues,
    errors,
    handleSelectChange,
    trainingStartDateState,
    setTrainingStartDate,
    trainingEndDateState,
    setTrainingEndDate,
    toggleBusinessRule,
    isBusinessRules,
    getBusinessRuleAliasOptions,
    selectedAlias,
    setSelectedAlias,
    selectedOperator,
    setSelectedOperator,
    businessRuleValue,
    setBusinessRuleValue,
    businessRuleName,
    setBusinessRuleName,
    addBusinessRuleButtonClassName,
    isBusinessRuleAddEnabled,
    handleAddBusinessRule,
    handleClearAllBusinessRules,
    businessRules,
    renderBusinessRuleRow,
    handleApplyBusinessRules,
    toggleForecastSelection,
    isForecastSelection,
    getCombinedTagAliases,
    forecastTagAlias,
    setForecastTagAlias,
    futureStartDateState,
    setFutureStartDate,
    futureEndDateState,
    setFutureEndDate,
    frequency,
    setFrequency,
    nameDesc,
    setNameDesc,
    handleForecast,
    canStartForecast,
    forecastButtonClassName,
    hasLiveForecastTable,
    handleViewForecastFromTable,
    liveForecastsData,
    updateForecastModelStatus,
    setLoading,
    deleteForecastModel,
    reloadForecastModels,
    canRenderTrainingChart,
    trainingChartContent,
    showForecastChart,
    forecastChartLoading,
    hasForecastChartData,
    forecastChartData,
    selectedAnomaly,
    forecastTagOrder,
    setSelectedAnomaly,
    isNoForecastDataPopup,
    setIsNoForecastDataPopup,
    isNoExistingModelsPopup,
    setIsNoExistingModelsPopup,
    isNoModelsFoundPopup,
    setIsNoModelsFoundPopup
  } = props;

  let businessRulesChevronIcon = IoIosArrowUp;
  if (isBusinessRules) {
    businessRulesChevronIcon = IoIosArrowDown;
  }

  let forecastSelectionChevronIcon = IoIosArrowUp;
  if (isForecastSelection) {
    forecastSelectionChevronIcon = IoIosArrowDown;
  }

  return (
    <>
      <div className='flex justify-center flex-col gap-10 items-center mt-4 mb-20'>
        {loading && <Loading />}
        <FormCard>
          <div>
            <span className='font-semibold text-2xl text-btn-primary'>
              Forecast
            </span>
            <p className='mt-3 text-[14.5px]'>
              Select inference period with ground truth data to see its forecasted values.
            </p>
            <form action='' className='mt-8'>
              <div className='flex gap-2 flex-col'>
                <div className='flex gap-4'>
                  <div className='flex flex-col w-full'>
                    <label htmlFor='assembly' className='mb-1'>
                      Assembly*
                    </label>
                    <Select
                      id='assembly'
                      className='w-full'
                      placeholder='Select Assembly'
                      options={(dropdownOptions.assemblyOptions ?? []).filter(
                        opt =>
                          opt.value !== null &&
                          opt.value !== undefined &&
                          opt.value !== ''
                      )}
                      isClearable
                      isSearchable
                      required
                      styles={customDropdownStyles}
                      value={selectedValues.selectedAssembly}
                      onChange={option =>
                        handleSelectChange('selectedAssembly', option)
                      }
                    />
                    {errors.selectedAssembly && (
                      <p className='text-red-500 text-[14.5px] mt-1'>
                        {errors.selectedAssembly}
                      </p>
                    )}
                  </div>
                  <div className='flex flex-col w-full'>
                    <label htmlFor='dgs-tags' className='mb-1'>
                      Dry Gas Seal Tags*
                    </label>
                    <Select
                      id='dgs-tags'
                      placeholder='Select Dry Gas Seal Tags'
                      isClearable
                      isSearchable
                      required
                      styles={customDropdownStyles}
                      options={(
                        dropdownOptions.dryGasSealTagsOptions ?? []
                      ).filter(
                        opt =>
                          opt.value !== null &&
                          opt.value !== undefined &&
                          opt.value !== ''
                      )}
                      value={selectedValues.selectedDryGasSealTags}
                      onChange={option =>
                        handleSelectChange('selectedDryGasSealTags', option)
                      }
                    />
                    {errors.selectedDryGasSealTags && (
                      <p className='text-red-500 text-[14.5px] mt-1'>
                        {errors.selectedDryGasSealTags}
                      </p>
                    )}
                  </div>
                  <div className='flex flex-col w-full'>
                    <label htmlFor='independent-tags' className='mb-1'>
                      Independent Tags
                    </label>
                    <Select
                      id='independent-tags'
                      placeholder='Select Independent Tags'
                      isClearable
                      isSearchable
                      isMulti
                      styles={customDropdownStyles}
                      options={(
                        dropdownOptions.independentTagsOptions ?? []
                      ).filter(
                        opt =>
                          opt.value !== null &&
                          opt.value !== undefined &&
                          opt.value !== ''
                      )}
                      value={selectedValues.selectedIndependentTags}
                      onChange={option =>
                        handleSelectChange('selectedIndependentTags', option)
                      }
                    />
                  </div>
                </div>
                <div className='flex gap-4'>
                  <div className='flex flex-col mt-2  w-full'>
                    <label htmlFor='start-date' className='mb-1'>
                      Training Start Date
                    </label>
                    <input
                      type='date'
                      id='traning-start-date'
                      className='custom-input'
                      value={trainingStartDateState}
                      onChange={e => setTrainingStartDate(e.target.value)}
                    />
                  </div>
                  <div className='flex flex-col mt-2  w-full'>
                    <label htmlFor='end-date' className='mb-1'>
                      Training End Date
                    </label>
                    <input
                      type='date'
                      id='training-end-date'
                      className='custom-input '
                      value={trainingEndDateState}
                      onChange={e => setTrainingEndDate(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className='mt-5'>
                <div
                  className='flex justify-between items-center  hover:bg-gray-100 py-3 px-2 hover:cursor-pointer'
                  onClick={toggleBusinessRule}
                >
                  <span className='text-btn-primary font-semibold flex items-center text-[16.5px]'>
                    Business Rules{' '}
                  </span>
                  {React.createElement(businessRulesChevronIcon, {
                    size: 20,
                    className: 'text-btn-primary cursor-pointer',
                    onClick: toggleBusinessRule
                  })}
                </div>
                {isBusinessRules && (
                  <>
                    <div className='flex gap-4 mb-4 items-center justify-center px-3'>
                      <div className='flex flex-col w-full'>
                        <label htmlFor='rule-name' className='mb-1'>
                          Alias{' '}
                        </label>
                        <Select
                          id='rule-name'
                          placeholder='Select Alias'
                          options={getBusinessRuleAliasOptions()}
                          value={selectedAlias}
                          isClearable
                          isSearchable
                          styles={customDropdownStyles}
                          onChange={setSelectedAlias}
                        />
                      </div>
                      <div className='flex flex-col w-full'>
                        <label className='mb-1' htmlFor='operator'>
                          Operator
                        </label>
                        <Select
                          id='operator'
                          placeholder='Select Operator'
                          options={[
                            { label: 'greater', value: 'greater' },
                            { label: 'lower', value: 'lower' },
                            { label: 'equal', value: 'equal' },
                            { label: 'not equal', value: 'not equal' }
                          ]}
                          isClearable
                          styles={customDropdownStyles}
                          value={selectedOperator}
                          onChange={setSelectedOperator}
                        />
                      </div>
                      <div className='flex flex-col w-full'>
                        <label htmlFor='value' className='mb-1'>
                          Value
                        </label>
                        <input
                          type='number'
                          id='value'
                          min={0}
                          value={businessRuleValue}
                          onChange={e => setBusinessRuleValue(e.target.value)}
                          className='custom-input '
                        />
                      </div>
                      <div className='flex flex-col w-full'>
                        <label htmlFor='business_rule_name' className='mb-1'>
                          Business Rule Name
                        </label>
                        <input
                          type='text'
                          id='business_rule_name'
                          placeholder='CUST_BR_NAME'
                          value={businessRuleName}
                          onChange={e => setBusinessRuleName(e.target.value)}
                          className='custom-input '
                        />
                      </div>
                      <div className='flex w-full gap-2 justify-center mt-6'>
                        <button
                          type='button'
                          className={addBusinessRuleButtonClassName}
                          disabled={!isBusinessRuleAddEnabled}
                          onClick={handleAddBusinessRule}
                        >
                          Add
                        </button>
                        <button
                          type='button'
                          className={'button-red'}
                          onClick={handleClearAllBusinessRules}
                        >
                          Clear all
                        </button>
                      </div>
                    </div>
                    {businessRules.length > 0 && (
                      <div className='mt-7'>
                        <div className='overflow-x-auto'>
                          <table className='min-w-full bg-white border border-gray-300 rounded'>
                            <thead>
                              <tr className='bg-gray-100 font-normal'>
                                <th className='px-3 py-2 border-b text-left'>
                                  Alias
                                </th>
                                <th className='px-3 py-2 border-b text-left'>
                                  Operator
                                </th>
                                <th className='px-3 py-2 border-b text-left'>
                                  Value
                                </th>
                                <th className='px-3 py-2 border-b text-left'>
                                  Business Rule Name
                                </th>
                                <th className='px-3 py-2 border-b text-left'>
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {businessRules.map((rule, idx) => renderBusinessRuleRow(rule, idx))}
                            </tbody>
                          </table>
                          <button
                            onClick={handleApplyBusinessRules}
                            type='button'
                            className={'bg-btn-primary px-10 text-white p-1.5 my-5 rounded-full h-10'}
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                )}
                <div
                  className='flex justify-between items-center  hover:bg-gray-100 py-3 px-2 hover:cursor-pointer'
                  onClick={toggleForecastSelection}
                >
                  <span className='text-btn-primary font-semibold flex items-center text-[16.5px]'>
                    Forecast Selection{' '}
                  </span>
                  {React.createElement(forecastSelectionChevronIcon, {
                    size: 20,
                    className: 'text-btn-primary cursor-pointer',
                    onClick: toggleForecastSelection
                  })}
                </div>
                {isForecastSelection && (
                  <>
                    <div className='flex flex-col '>
                      <div className='flex gap-4 mb-2'>
                        <div className='flex flex-col w-full'>
                          <label htmlFor='rule-name' className='mb-1'>
                            Tag Alias{' '}
                          </label>
                          <Select
                            id='forecast-tags'
                            placeholder='Select the Tags'
                            isClearable
                            isSearchable
                            isMulti
                            required
                            styles={customDropdownStyles}
                            options={getCombinedTagAliases(
                              selectedValues.selectedDryGasSealTags,
                              selectedValues.selectedIndependentTags
                            ).map(tag => ({
                              label: tag,
                              value: tag
                            }))}
                            value={forecastTagAlias}
                            onChange={setForecastTagAlias}
                          />
                        </div>
                        <div className='flex flex-col  w-full'>
                          <label htmlFor='future-start-date' className='mb-1'>
                            Future Start Date
                          </label>
                          <input
                            type='date'
                            id='future-start-date'
                            className='custom-input'
                            value={futureStartDateState}
                            onChange={e => setFutureStartDate(e.target.value)}
                          />
                        </div>
                        <div className='flex flex-col  w-full'>
                          <label htmlFor='end-date' className='mb-1'>
                            Future End Date
                          </label>
                          <input
                            type='date'
                            id='future-end-date'
                            className='custom-input '
                            value={futureEndDateState}
                            onChange={e => setFutureEndDate(e.target.value)}
                          />
                        </div>
                        <div className='flex flex-col w-full'>
                          <label htmlFor='frequency' className='mb-1'>
                            Frequency{' '}
                            {frequency && <i> = {frequency} mins</i>}{' '}
                          </label>
                          <div className='w-full flex items-end'>
                            <input
                              type='number'
                              id='frequency'
                              placeholder='Enter frequency in mins'
                              value={frequency}
                              min={1}
                              onChange={e => {
                                const val = Number(e.target.value);
                                if (e.target.value === '' || val < 1) {
                                  setFrequency('');
                                } else {
                                  setFrequency(val);
                                }
                              }}
                              className='custom-input w-full'
                            />
                            <span className='text-gray-500 ml-2'>mins</span>
                          </div>
                        </div>
                      </div>
                      <div className='flex gap-4 '>
                        <div className='flex flex-col mt-2  w-full'>
                          <label htmlFor='name' className='mb-1'>
                            Name
                          </label>
                          <input
                            type='text'
                            id='name'
                            placeholder='Enter name'
                            className='custom-input'
                            value={nameDesc.name}
                            onChange={e =>
                              setNameDesc(prev => ({
                                ...prev,
                                name: e.target.value
                              }))
                            }
                          />
                        </div>
                        <div className='flex flex-col mt-2  w-full'>
                          <label htmlFor='description' className='mb-1'>
                            Description (optional)
                          </label>
                          <input
                            type='text'
                            id='description'
                            placeholder='Enter description'
                            className='custom-input'
                            value={nameDesc.desc}
                            onChange={e =>
                              setNameDesc(prev => ({
                                ...prev,
                                desc: e.target.value
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <button
                      type='button'
                      onClick={() =>
                        toast.promise(handleForecast(), {
                          loading: 'Applying changes...',
                          success: <b>Forecast started!</b>,
                          error: <b>Failed to start the forecast.</b>
                        })
                      }
                      disabled={!canStartForecast}
                      className={forecastButtonClassName}
                    >
                      {'Forecast'}
                    </button>
                  </>
                )}
              </div>
            </form>
          </div>
        </FormCard>
        {hasLiveForecastTable &&
          <LiveForecastsTable
            onViewForecast={handleViewForecastFromTable}
            modelsData={liveForecastsData}
            updateModelStatus={updateForecastModelStatus}
            loading={loading}
            setLoading={setLoading}
            deleteModel={deleteForecastModel}
            reloadModels={reloadForecastModels}
          />
        }
        {canRenderTrainingChart && trainingChartContent}
        {showForecastChart && forecastChartLoading && (
          <p className='text-gray-600'>Loading chart. Please wait...</p>
        )}
        {hasForecastChartData && (
          <ForecastChart
            forecastData={forecastChartData}
            selectedAnomaly={selectedAnomaly}
            tagOrder={forecastTagOrder}
          />
        )}
        {hasForecastChartData && (
          <AnomaliesTable
            data={forecastChartData}
            selectedTags={forecastTagAlias}
            onRowSelect={setSelectedAnomaly}
          />
        )}
      </div>
      {isNoForecastDataPopup && (
        <ConfirmationPopup
          message={'No forecast data available for the selected model.'}
          onConfirm={() => setIsNoForecastDataPopup(false)}
          onCancel={() => setIsNoForecastDataPopup(false)}
          cancelButtonMsg={''}
          confirmButtonMsg={'OK'}
        />
      )}
      {isNoExistingModelsPopup && (
        <ConfirmationPopup
          message={'No existing forecast models found.'}
          onConfirm={() => setIsNoExistingModelsPopup(false)}
          onCancel={() => setIsNoExistingModelsPopup(false)}
          cancelButtonMsg={''}
          confirmButtonMsg={'OK'}
        />
      )}
      {isNoModelsFoundPopup && (
        <ConfirmationPopup
          message={'No forecast models found.'}
          onConfirm={() => setIsNoModelsFoundPopup(false)}
          onCancel={() => setIsNoModelsFoundPopup(false)}
          cancelButtonMsg={''}
          confirmButtonMsg={'OK'}
        />
      )}
    </>
  );
};

export default ForecastFormView;
